import { buildListSearch, parseListPage } from "./listQueryParams";

export const ADMIN_NOTIFICATIONS_PATH = "/admin/notifications";

export type AdminNotificationsListQuery = {
  page: number;
};

export const parseAdminNotificationsListQuery = (
  search: string
): AdminNotificationsListQuery => {
  const params = new URLSearchParams(search);
  return {
    page: parseListPage(params.get("page")),
  };
};

export const buildAdminNotificationsListSearch = (
  query: AdminNotificationsListQuery
): string => buildListSearch(query);
